import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  cardWrapper: {
    width: '100%',
    minHeight: '65px',
    backgroundColor: 'white',
    border: '0.1px solid rgba(0, 0, 0, 10%)',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '25px',
    padding: '10px 25px',
    height: '100%',
  },
  cardTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 3,
    marginBlock: '15px',
    alignSelf: 'flex-start',
  },
  cardTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  cardSubTitle: {
    marginTop: '-5px',
    fontSize: '12px',
    color: 'gray',
  },
  cardFileWrapper: {
    flex: 5,
    display: 'flex',
    flexFlow: 'row wrap',

    // Override Upload file list styles for inline display.
    '& .ant-upload-list': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: '8px',
    },

    '& .ant-upload-list-item': {
      display: 'flex',
      alignItems: 'center',
      // Adjust the spacing or minWidth if needed
    },

    // Make the PDF icon and paperclip icon bigger
    '& .ant-upload-list-item .anticon': {
      fontSize: '18px',
      width: '18px',
      height: '18px',
      lineHeight: '18px',
      backgroundColor: 'blue',
    },

    // Specifically enlarge the remove/delete icon
    '& .ant-upload-list-item-card-actions .anticon-delete, .ant-upload-list-item-card-actions .anticon-close': {
      fontSize: '18px',
      width: '18px',
      height: '18px',
    },
  },
  cardCheckboxWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  cardOptionWrapper: {
    flex: 0,
    fontSize: '12px',
  },
  uploadSectionWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  uploadSlotWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
  },
  uploadSlot: {
    width: '100%',
    height: '40px',
    border: '1px solid #d9d9d9',
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 12px',
  },
  uploadSlotWithFile: {
    backgroundColor: '#f6ffed',
    border: '1px solid #b7eb8f',
  },
  uploadSlotFileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  cardGhost: {
    opacity: 0.4,
    border: '2px dashed gold',
  },
});
